import React, { useEffect, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import { logoblue } from "../assets/styles";

const WhatPage = () => {
  const items = [
    "Free Counceling",
    "Floor Plan",
    "Interior Designing",
    "Architecture (Indoor)",
    "Exterior Architecture",
    "3D Designs",
  ];

  const sectionRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const rect = sectionRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // START REVEAL ONLY when section is 40–60% inside viewport
      if (rect.top < windowHeight * 0.6 && rect.bottom > windowHeight * 0.2) {
        // Calculate scroll depth inside section (more accurate)
        const sectionVisibleAmount = windowHeight * 0.6 - rect.top;

        const progress = sectionVisibleAmount / (rect.height * 0.9); // less sensitive

        const maxItems = items.length;

        let count = Math.floor(progress * maxItems);

        if (count < 0) count = 0;
        if (count > maxItems) count = maxItems;

        setVisibleCount(count);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box sx={{ width: "100%", overflowX: "hidden" }}>
      <Box
        ref={sectionRef}
        sx={{
          display: "flex",
          flexDirection: "column",
          maxWidth: "90%",
          alignItems: "center",
          gap: 3,
          px: { xs: 3, md: 10 },
          py: { xs: 6, md: 8 },
          backgroundColor: "#fff",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: "#b2925a",
            fontFamily: "serif",
            textDecoration: "underline",
            mt: 8,
            textAlign: "center",
          }}
        >
          What we do?
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            flexWrap: "wrap",
            justifyContent: { md: "space-around" },
            alignItems: "center",
            gap: 3,
          }}
        >
          {items.map((text, index) => (
            <Typography
              key={index}
              sx={{
                opacity: visibleCount > index ? 1 : 0,
                transform:
                  visibleCount > index ? "translateY(0px)" : "translateY(30px)",
                transition: "all 0.5s ease-out",
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 600,
                backgroundColor: logoblue,
                color: "white",
                width: "250px",
                marginX: { md: "100px" },
                letterSpacing: 1,
                py: 2,
                px: 2,
                borderRadius: "5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                gap: 1,
              }}
            >
              <StarIcon fontSize="small" sx={{ color: "#fdff00" }} />
              {text}
            </Typography>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default WhatPage;
